import React, { Component } from "react";
import "./board-page.scss";

class BoardPage extends Component {
  state = {};
  render() {
    return (
      <>
        <div className="boardWrapper">
          <div className="sideDoc">
            <div className="logoWrapper">
              <img src={require("../../assets/images/C-01.png")} alt="" />
            </div>
          </div>
          <div className="boardBarOuterWrapper">
            <div className="boardBar"></div>
            <div className="actions">
              <input type="text" placeholder="Search" />
            </div>
            <div className="boardContentsWrapper">
              <div className="content">
                <div className="title">
                  Here goes something that you have added...
                </div>
                <div className="bottomBar">
                  <div className="type">
                    <i class="fas fa-align-right"></i> Raw Text
                  </div>
                  <div className="type">
                    <i class="fas fa-clock"></i> 3 mins ago
                  </div>
                </div>
              </div>
              <div className="content">
                <div className="title">
                  Here goes something that you have added...
                </div>
                <div className="bottomBar">
                  <div className="type">
                    <i class="fas fa-align-right"></i> Raw Text
                  </div>
                  <div className="type">
                    <i class="fas fa-clock"></i> 3 mins ago
                  </div>
                </div>
              </div>
              <div className="content">
                <div className="title">
                  Here goes something that you have added...
                </div>
                <div className="bottomBar">
                  <div className="type">
                    <i class="fas fa-align-right"></i> Raw Text
                  </div>
                  <div className="type">
                    <i class="fas fa-clock"></i> 3 mins ago
                  </div>
                </div>
              </div>
              <div className="content">
                <div className="title">
                  Here goes something that you have added...
                </div>
                <div className="bottomBar">
                  <div className="type">
                    <i class="fas fa-align-right"></i> Raw Text
                  </div>
                  <div className="type">
                    <i class="fas fa-clock"></i> 3 mins ago
                  </div>
                </div>
              </div>
              <div className="content">
                <div className="title">
                  Here goes something that you have added...
                </div>
                <div className="bottomBar">
                  <div className="type">
                    <i class="fas fa-align-right"></i> Raw Text
                  </div>
                  <div className="type">
                    <i class="fas fa-clock"></i> 3 mins ago
                  </div>
                </div>
              </div>
              <div className="content">
                <div className="title">
                  Here goes something that you have added...
                </div>
                <div className="bottomBar">
                  <div className="type">
                    <i class="fas fa-align-right"></i> Raw Text
                  </div>
                  <div className="type">
                    <i class="fas fa-clock"></i> 3 mins ago
                  </div>
                </div>
              </div>
              <div className="content">
                <div className="title">
                  Here goes something that you have added...
                </div>
                <div className="bottomBar">
                  <div className="type">
                    <i class="fas fa-align-right"></i> Raw Text
                  </div>
                  <div className="type">
                    <i class="fas fa-clock"></i> 3 mins ago
                  </div>
                </div>
              </div>
              <div className="content">
                <div className="title">
                  Here goes something that you have added...
                </div>
                <div className="bottomBar">
                  <div className="type">
                    <i class="fas fa-align-right"></i> Raw Text
                  </div>
                  <div className="type">
                    <i class="fas fa-clock"></i> 3 mins ago
                  </div>
                </div>
              </div>
              <div className="content">
                <div className="title">
                  Here goes something that you have added...
                </div>
                <div className="bottomBar">
                  <div className="type">
                    <i class="fas fa-align-right"></i> Raw Text
                  </div>
                  <div className="type">
                    <i class="fas fa-clock"></i> 3 mins ago
                  </div>
                </div>
              </div>
              <div className="content">
                <div className="title">
                  Here goes something that you have added...
                </div>
                <div className="bottomBar">
                  <div className="type">
                    <i class="fas fa-align-right"></i> Raw Text
                  </div>
                  <div className="type">
                    <i class="fas fa-clock"></i> 3 mins ago
                  </div>
                </div>
              </div>

              <div className="content">
                <div className="title">
                  Here goes something that you have added...
                </div>
                <div className="bottomBar">
                  <div className="type">
                    <i class="fas fa-align-right"></i> Raw Text
                  </div>
                  <div className="type">
                    <i class="fas fa-clock"></i> 3 mins ago
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="contentArea">
            <textarea name="" id="" cols="30" rows="10"></textarea>
          </div>
        </div>
      </>
    );
  }
}

export default BoardPage;
